export default import.meta.ROLLUP_FILE_URL_Q3UBAHz6jvQE8hoDGIJZKA